export default __webpack_public_path__ + "static/media/Pistol_9.e6c35f51.png";